import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ContentChild, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-right-side-drawer',
  templateUrl: './right-side-drawer.component.html',
  styleUrls: ['./right-side-drawer.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('400ms', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class RightSideDrawerComponent implements OnInit {
  @ContentChild('contentHeader') contentHeader: any = '';
  @ContentChild('content') content: any = '';
  @Input() show: boolean = false;
  @Input() customStyle: string = 'height: calc(100vh - 300px)';
  constructor() {}

  ngOnInit(): void {}
}
